
const SiteMapLinks = (props) => {
    return (
        <div className='site-map-content'>
            {props.GeneralLinks && props.GeneralLinks.length > 0 &&
                <>
                    <h3>{props.PageTitle}</h3>
                    <div className='general-links'>
                        {props.GeneralLinks.map(link =>
                            <div key={link.LinkURL} className='link-container'>
                                <a href={link.LinkURL} target={link.LinkTarget} rel={link.LinkRelation ? link.LinkRelation : null} aria-label={link.LinkTarget == '_blank' ? link.LinkText + " (" + translator.translate('sandhills.opensinanewtab') + ")" : link.LinkText}>{link.LinkText}</a>
                            </div>)}
                    </div>
                {props.LinkSections && props.LinkSections.length > 0 &&
                    <>
                        {props.SubHeadingText && <h3>{props.SubHeadingText}</h3>}
                        {props.LinkSections.map(section =>
                            <div key={section.SectionHeader} className='for-sale-listings'>
                                {section.SectionHeader && <h4>{section.SectionHeader}</h4>}
                                {section.Links.map(link =>
                                    <div key={link.LinkURL} className='link-container'>
                                        <a href={link.LinkURL} target={link.LinkTarget} aria-label={link.LinkTarget == '_blank' ? link.LinkText + " (" + translator.translate('sandhills.opensinanewtab') + ")" : link.LinkText}>{link.LinkText}</a>
                                    </div>)}
                            </div>)}
                    </>}
                </>}
        </div>
    );
};

export default SiteMapLinks;